import { useState } from "react";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const Auth = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(true);
  const [, setCookie] = useCookies(["access_token"]);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const path = isRegister ? "register" : "login";
    const Notifications = (msg) => toast(msg);

    if (isRegister) {
      try {
        await axios.post(`https://blogapi21.onrender.com/auth/${path}`, {
          username,
          password,
        });
        Notifications("Successfully Registered");
      } catch (error) {
        if (error.response && error.response.status === 400) {
          Notifications(error.response.data.message);
        } else {
          console.error(error);
          Notifications("Registration failed. Please try again later.");
        }
      }
    } else {
      try {
        const result = await axios.post(`https://blogapi21.onrender.com/auth/${path}`, {
          username,
          password,
        });
        setCookie("access_token", result.data.token);
        window.localStorage.setItem("username", result.data.username);
        window.localStorage.setItem("UserID", result.data.UserID);
        navigate("/");
      } catch (error) {
        if (error.response && error.response.status === 400) {
          Notifications(error.response.data.message);
        } else {
          console.error(error);
          alert("Login failed. Please try again later.");
        }
      }
    }
  };

  return (
    <>
      <div className="flex justify-center align-middle mt-[12.5%]">
        <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-secondary">
          <div className="card-body">
            <div className="form-control">
              <label className="label">
                <span className="label-text text-secondary-content">
                  Username
                </span>
              </label>
              <input
                type="text"
                placeholder="Username"
                className="input input-bordered"
                id="username"
                onChange={(e) => setUsername(e.target.value)}
                value={username}
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text text-secondary-content">
                  Password
                </span>
              </label>
              <input
                type="password"
                placeholder="password"
                className="input input-bordered"
                id="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
            </div>
            <div className="form-control mt-6 flex w-full">
              <div className="flex w-full justify-center">
                <button
                  type="submit"
                  className="btn btn-secondary-content text-secondary-content"
                  onClick={handleSubmit}
                >
                  {isRegister ? "Register" : "Login"}
                </button>
                <div className="divider divider-horizontal">OR</div>
                <button
                  type="button"
                  className="btn btn-secondary-content text-secondary-content"
                  onClick={() => setIsRegister(!isRegister)}
                >
                  {isRegister ? "Switch to Login" : "Switch to Register"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
